/**
 * 观众中心商城金额展示：统一美元
 * @param {number|string} val
 * @returns {string} e.g. $45.00
 */
export function spectatorMoney(val) {
  if (val == null || val === '') {
    return '$0';
  }
  if (typeof val === 'string' && val.indexOf('-') !== -1 && /[^\d.\-\s]/.test(val) === false) {
    // "45 - 78" 区间
    return val
      .split('-')
      .map(function (part) {
        return spectatorMoney(part.trim());
      })
      .join(' - ');
  }
  const n = Number(val);
  if (isNaN(n)) {
    return '$' + val;
  }
  const fixed = Math.round(n * 100) / 100;
  const text = Number.isInteger(fixed) ? String(fixed) : fixed.toFixed(2);
  return '$' + text;
}

export const SPECTATOR_CURRENCY = 'USD';



// WEBPACK FOOTER //
// ./src/utils/spectatorMoney.js